module.exports = __webpack_public_path__ + "static/media/Clark-Schools-Graduating-300x250.7259c912.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ads/Clark-Schools-Graduating-300x250.gif
// module id = 30
// module chunks = 0